export const landDevelopmentPage = {
  hero: {
    eyebrow: 'Land development',
    title: 'Establish the landscape around your next development.',
    intro:
      'Bring new sites and communities into their surroundings with planting, ground cover and stabilization services matched to the property.',
    primary: { label: 'Discuss your site', href: '/contact' },
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/land-development-logo-cleaned-20261029.png',
    alt: 'A D.A. Alexander crew transporting mature trees for site planting.',
  },
  services: {
    title: 'From site planting to ground cover.',
    intro:
      'Coordinate the landscape elements that establish a new site, from its entry and street trees to its seeded areas and slopes.',
    groups: [
      {
        id: 'plantings-site-features',
        title: 'Plantings & site features',
        items: [
          'Site development plantings',
          'Street tree installation',
          'Entry features',
          'Retaining walls and landscape enhancements',
        ],
      },
      {
        id: 'seeding-sod',
        title: 'Seeding & sod',
        items: ['Hydroseeding', 'Temporary and permanent seeding', 'Sod installation'],
      },
      {
        id: 'stabilization',
        title: 'Stabilization',
        items: ['Soil stabilization', 'Pond and swale stabilization', 'Erosion matting', 'Straw blowing'],
      },
    ],
  },
  support: {
    title: 'Support for active sites.',
    text: 'Need construction sweeping, road scraping or site cleanup? Explore the commercial services available for your property.',
    link: { label: 'Commercial & seasonal services', href: '/commercial-seasonal-services' },
  },
  closing: {
    title: 'Tell us what your site needs.',
    text: 'Share the location, type of development and landscape work you have in mind. We’ll help you find the right place to start.',
    action: { label: 'Discuss your project', href: '/contact' },
  },
};
